import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";

interface CustomCheckIconButtonProps {
  handleSubmit: () => void;
  currentInputValue: string;
}

export default function CustomCheckIconButton({
  currentInputValue,
  handleSubmit,
}: CustomCheckIconButtonProps): JSX.Element {
  const currentBackgroundColor =
    currentInputValue.trim() !== ""
      ? "primary.main"
      : "action.disabledBackground";

  return (
    <IconButton
      id="custom-value-button"
      sx={{
        backgroundColor: currentBackgroundColor,
        borderRadius: 0,
        width: "40px",
        height: "40px",
        "&:hover": {
          backgroundColor:
            currentInputValue.trim() !== "" ? "primary.dark" : " ",
        },
        cursor: currentInputValue.trim() !== "" ? "pointer" : "default",
      }}
      onClick={handleSubmit}
      disableRipple={currentInputValue.trim() === ""}
    >
      <CheckIcon style={{ color: "white" }} />
    </IconButton>
  );
}
